import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import React, { useEffect, useContext, useState } from "react";
import { ThemeContext } from '../../themes/theme';
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin, SidebarTab } from '@react-pdf-viewer/default-layout';
import { zoomPlugin } from '@react-pdf-viewer/zoom';

type Props = {
    pdfBlob?: Blob;
}

const PdfViewer: React.FC<Props> = (props) => {
    const themeContext = useContext(ThemeContext);
    const isDarkMode = themeContext?.theme === "dark";

    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const zoomPluginInstance = zoomPlugin();
    const { zoomTo } = zoomPluginInstance;

    const [pdfUrl, setPdfUrl] = useState<string | null>(null);

    useEffect(() => {
        const fetchPdf = async () => {
            if (props.pdfBlob) {
                const url = URL.createObjectURL(props.pdfBlob);
                setPdfUrl(url);
            }
        };

        fetchPdf();
    }, [props]);

    useEffect(() => {
        if (zoomTo) {
            const containerWidth = window.innerWidth;
            const pageWith = 800;
            const fullPageZoom = containerWidth / pageWith;

            zoomTo(fullPageZoom);
        }
    }, [zoomTo]);

    return (
        <Worker workerUrl='\pdfjs\pdf.worker.min.js'>
            {pdfUrl && 
                <Viewer 
                    theme={`${isDarkMode ? 'dark' : ''}`}
                    fileUrl={pdfUrl}
                    plugins={[defaultLayoutPluginInstance, zoomPluginInstance]}
                />
            }
        </Worker>
    )
}

export default PdfViewer;